var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"speakingMessage",staticClass:"speaking-message",class:{
    'speaking-message': true,
    'speaking-message--left': _vm.direction === 'left',
    'speaking-message--right': _vm.direction === 'right',
    'speaking-message--outline': _vm.outline,
  }},[_c('img',{staticClass:"speaking-message__avatar",attrs:{"alt":"User Avatar","title":"User Avatar","src":_vm.avatar}}),_c('div',{staticClass:"speaking-message__text"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }